import { Pipe, PipeTransform } from '@angular/core';
import { STAND_STATUSES_RELATED_NAMES, StandStatus } from 'shared';

@Pipe({
  name: 'standStatusPipe',
  standalone: true
})
export class StandStatusPipePipe implements PipeTransform {
  transform(value: any): string {
    return STAND_STATUSES_RELATED_NAMES[value as unknown as StandStatus] || value;
  }
}
